module.exports = __webpack_public_path__ + "static/media/password-lock.05c16ab4.svg";